<template>
  <div>
    <material-card
      :text="`${title}`"
      color="orange"
      title="Account Inventory">
      <v-layout
        class="account-filters ml-2 mr-2"
        justify-start
        align-center
        wrap>
        <v-flex md2>
            <v-select
              v-model="searchField"
              :items="searchColumns"
              :menu-props="{ maxHeight: '400' }"
              label="Select a field to Search"
              attach
              clearable
            />
        </v-flex>
        <v-flex md2>
            <v-text-field
              v-model.trim="searchInput"
              label="Search here..."
              clearable
            />
        </v-flex>
        <v-flex
          sm4
          md2
          class="agreement-type">
          <v-select
            v-model="agreementFilter"
            :items="masterlists"
            item-value="value"
            label="Agreement"
            attach/>
        </v-flex>
        <v-flex
          sm4
          md2 >
          <v-select
            v-model="accountStatusFilter"
            :items="acctStatusItems"
            item-text="text"
            item-value="value"
            attach
            label="Account Status"
            multiple
          />
        </v-flex>
        <!-- 
        <v-flex md2>

          <v-select
            v-model="groupAliasFilter"
            :items="masterAccounts"
            item-text="Acct_Alias_Group"
            item-value="Acct_Alias_Group"
            attach
            chips
            label="Filter By Account Group"
            multiple
            solo
          />
        </v-flex> -->
        <v-flex md1>
          <v-checkbox
            v-model="deletedFilter"
            value="1"
            false-value="0"
            true-value="1"
            color="orange"
            label="Deleted"
          />
        </v-flex>
        <v-flex md1>
          <v-checkbox
            v-model="archivedAcctStatus"
            value="1"
            false-value="0"
            true-value="1"
            color="orange"
            label="Archived"
          />
        </v-flex>
        <Can
          i="report"
          a="inventory">
          <v-flex style="text-align: right">
            <v-btn small @click="downloadAccounts" :loading="downloadingAccount"><v-icon>mdi-download</v-icon> &nbsp;Download</v-btn>
            <!-- <HelperCsvDownload
              :data="filteredAccounts"
              :getData="getFilteredAccounts"
              :title="'Download All'"
              @csv-download-success="downloadFinished"/> -->
          </v-flex>
        </Can>
      </v-layout>
      <v-layout
        v-show="selected.length > 0"
        align-end
        justify-end
        row
        fill-height
        class="mass-update-actions"
        transition="fade-transition">
        <v-flex
          md4
          align-self-center>
          <p class="subtitle-1 mb-0"><span class="font-weight-black">({{ selected.length }})</span> accounts selected</p>
        </v-flex>
        <v-flex
          md8
          style="text-align: right">
          <v-btn
            v-if="deletedFilter == '1'"
            small
            class="mr-2"
            color="orange"
            @click="unArchiveAccount(selected)" ><v-icon left>reply</v-icon>Restore Accounts</v-btn>
          <Can
            I="manage"
            a="admin">
            <v-btn
              small
              class="mr-2"
              color="orange"
              @click="updateLastDateValidated = true" >Update Last Validated</v-btn>
          </Can>
        </v-flex>
      </v-layout>
      <v-data-table
        id="virtual-scroll-table"
        ref="accountList"
        :headers="getAccountHeaders"
        :items="accountData"
        v-model="selected"
        hide-actions
        class="accounts-table"
        loading
        loading-text="Loading... Please wait"
        select-all
        item-key="Acct_ID"
      >
        <template
          slot="headerCell"
          slot-scope="{ header }">
          <span
            class="subheading font-weight-light text-success text-md-left text--darken-3"
            v-text="header.text"
          />
        </template>
        <template v-slot:items="props">
          <tr :active="props.selected" >
            <td>
              <v-checkbox
                v-model="props.selected"
                color="orange"
                hide-details
              />
            </td>
            <td>
              
              <v-layout
                align-left
                justify-left>
                <Can
                  i="read"
                  a="inventory">
                  <v-icon
                    small
                    title="View"
                    class="mr-2 ml-2"
                    color="primary"
                    flat
                    @click="openItem('view', props.item)">visibility</v-icon>
                </Can>
                <Can
                  i="write"
                  a="inventory">
                  <v-icon
                    small
                    title="Edit"
                    class="mr-2"
                    color="primary"
                    flat
                    @click="openItem('edit', props.item)">edit</v-icon>
                </Can>
                <Can
                  i="write"
                  a="inventory">
                  <v-icon
                    v-if="deletedFilter != '1'"
                    small
                    title="Delete"
                    class="mr-2"
                    color="primary"
                    flat
                    @click="flagAccount(props.item)">delete</v-icon>
                  <v-icon
                    v-if="deletedFilter == '1'"
                    small
                    title="Restore"
                    class="mr-2"
                    color="primary"
                    flat
                    @click="unArchiveAccount(props.item)">restore_page</v-icon>
                  <v-icon
                    small
                    title="Clone"
                    class="mr-2"
                    color="primary"
                    flat
                    @click="cloneAccount(props.item)">folder_shared</v-icon>
                </Can>
                <v-icon
                  small
                  title="Changelogs"
                  class="mr-2"
                  color="primary"
                  flat
                  @click="onShowLogs(props.item)">history</v-icon>
              </v-layout>
            </td>
            <td>{{ props.item.OppReg_Id }}</td>
            <td>{{ props.item.ACE_Opportunity_Number }}</td>
            <td>{{ props.item.AWS_EUR_Date }}</td>
            <td>{{ props.item.AWS_ACE_Launch_Date }}</td>
            <td>{{ props.item.Acct_name }}</td>
            <td>{{ props.item.Acct_Status }}</td>
            <td>{{ props.item.Acct_Alias_Group }}</td>
            <td>{{ props.item.Acct_Offering_Stat }}</td>
            <td>{{ props.item.Acct_DL }}</td>
            <td>{{ props.item.Acct_ID }}</td>
            <td>{{ props.item.Date_onboarded }}</td>
            <td>{{ props.item.Last_Date_Validated }}</td>
            <td>{{ props.item.Date_Suspended }}</td>
            <td>{{ props.item.MP_ID }}</td>
            <td>
              <div v-if="props.item.DateMarkedAsUnknown !== 'None' && props.item.MP_Name.includes('UNKNOWN')">
                <v-chip
                  color="orange"
                  text-color="white">
                  <span v-html="daysMarkedAsUnknown(props.item.DateMarkedAsUnknown)"/>
                </v-chip>
              </div>
              <div v-else>
                None
              </div>
            </td>

            <td>{{ props.item.Previous_MP_ID }}</td>
            <td>{{ props.item.Customer_Name }}</td>
            <td>{{ props.item.Managed_Svc }}</td>
            <td>{{ props.item.AWS_Support_Type }}</td>
            <td>{{ props.item.Customer_Region }}</td>
            <td>{{ props.item.Acct_Restricted }}</td>
            <td>{{ props.item.MFA }}</td>
            <td>{{ props.item.Root_Credential_Store }}</td>
            <td>{{ props.item.DXC_discount }}</td>
            <td>{{ props.item.Client_discount }}</td>
            <td>{{ props.item.MP_uplift }}</td>
            <td>{{ props.item.Client_uplift }}</td>
            <td>{{ props.item.WBS_code }}</td>
            <td>{{ props.item.IWO_Code }}</td>
            <td>{{ props.item.Comments }}</td>
            <td>{{ props.item.AWS_Usage_Type }}</td>
            <td>{{ props.item.AWS_Government_Customer }}</td>
            <td>{{ props.item.AWS_Advising_Government }}</td>
            <td>{{ props.item.GovCloud_Resource_Account }}</td>
          </tr>
        </template>
      </v-data-table>
      <v-progress-linear
        v-if="loadingAccountData"
        v-slot:progress
        color="orange"
        indeterminate/>
      <div class="text-xs-center mt-3">
        <v-btn :disabled="!nextPaginationKey || loadingAccountData" small @click="showNextData">LOAD MORE...</v-btn>
      </div>
    </material-card>
    <!-- MODAL -->
    <v-dialog
      v-model="updateLastDateValidated"
      persistent
      max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Update Last Validated Date</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-layout
              row
              wrap>
              <v-flex
                xs12
                sm12
                md10
                xl10>
                <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="lastDateVal"
                      label="Last Date Validated"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    v-model="lastDateVal"
                    @input="menu2 = false"/>
                </v-menu>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-layout
            align-end
            justify-end>
            <v-btn
              color="orange darken-1"
              text
              @click="updateLastDateValidated = false">Close</v-btn>
            <v-btn
              :loading ="lastDateValidatedStatus"
              color="orange darken-1"
              text
              @click="updateLastDateValidatedField()">Save</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapMutations, mapState, mapGetters } from 'vuex'

import {debounce} from '../../../utils/helper'

export default {

  props: {
    title: {
      type: String,
      default: 'byAwsAgreement' // i.e. byAwsAgreement, byMasterPayer, byCustomer
    },
    type: {
      type: String,
      default: 'byAwsAgreement' // i.e. byAwsAgreement, byMasterPayer, byCustomer
    }
  },
  data: () => ({
    selected: [],
    selectedMiscFilter: [],
    selectedAcctStatus: ['New', 'ACTIVE'],
    selectedCustAliasGroup: [
      {
        text:'None',
        value: 'None'
      },
       {
        text:'Group123',
        value: 'Group123'
      },
       {
        text:'Group4',
        value: 'Group4'
      }
      
    ] ,
    updateLastDateValidated: false,
    lastDateVal: new Date().toISOString().substr(0, 10),
    menu2: false,
    searchInput: '',
    searchField: 'Acct_ID',
    searchColumns: [
      {
        text: 'Account ID', 
        value:'Acct_ID'
      },
      {
        text: 'Account Name', 
        value:'Acct_Name'
      },
      {
        text: 'Account DL', 
        value:'Acct_DL'
      },
      {
        text: 'Customer Name', 
        value:'Customer_Name'
      },
      {
        text: 'Master Payer ID', 
        value:'MP_ID'
      },
      {
        text: 'OppReg ID', 
        value:'OppReg_Id'
      },
    ],
    acctStatusItems: [
      {
        text: 'New',
        value: 'New'
      },
      {
        text: 'Active',
        value: 'ACTIVE'
      },
      {
        text: 'Suspended',
        value: 'SUSPENDED'
      },
      {
        text: 'Moved to Client',
        value: 'Moved to Client'
      },
      {
        text: 'Active - Not in Use',
        value: 'Active - Not in Use'
      }
    ],
    groupAliasFilter: [],
    masterlists: [
      {
        text: 'PPA',
        value: 'ppa'
      },
      {
        text: 'SPP',
        value: 'spp'
      },
      {
        text: 'Single Payer',
        value: 'sp'
      },
      {
        text: 'Other',
        value: 'other'
      },
      {
        text: 'All',
        value: 'all'
      },
      {
        text: 'Gold',
        value: 'gold'
      },
      {
        text: 'Restricted Accounts',
        value: 'restricted'
      },
      {
        text: 'Unknown Accounts',
        value: 'UNKNOWN'
      }
    ],
    blurConfig: {
      isBlurred: true,
      opacity: 0.9,
      filter: 'blur(2.2px)',
      transition: 'all .5s linear'
    }
  }),
  mounted() {
    console.log('MOUNTED')
  },
  computed: {
    ...mapState('admin/accountInventory', ['accountData', 'accountDataFilters', 'loadingAccountData', 'downloadingAccount', 'nextPaginationKey',  'pods', 'accountHeaders', 'acctStatusFilter', 'acctMiscFilter', 'lastDateValidatedStatus']),
    ...mapState('admin', ['customers']),
    ...mapGetters({
      getAccountHeaders: 'admin/accountInventory/getAccountHeaders'
    }),
    agreementFilter: {
      get: function() {
        return this.accountDataFilters.Agreement
      },
      set: function(value) {
        this.accountDataFilters.Agreement = value
      }
    },
    accountStatusFilter: {
      get: function() {
        return this.accountDataFilters.Acct_Status
      },
      set: function(value) {
        this.accountDataFilters.Acct_Status = value
      }
    },
    deletedFilter: {
      get: function(){
        return this.accountDataFilters.deleted
      },
      set: function(value) {
        this.accountDataFilters.deleted = value
      }
    },
    archivedAcctStatus: {
      get: function(){
        return this.accountDataFilters.archived
      },
      set: function(value) {
        this.accountDataFilters.archived = value
      }
    }
  },
  methods: {
    showNextData() {
      this.$store.dispatch('admin/accountInventory/getAccounts', { paginate: 'next'})
    },
    getFilteredAccounts () {
      this.pagination.rowsPerPage = -1
      let data = this.$refs.accountList.filteredItems
      this.pagination.rowsPerPage = 10
      return data
    },
    downloadFinished () {
      console.log('download finished')
      this.pagination.rowsPerPage = 10
    },
    verifyContactsValue (contactValue) {
      if (contactValue == 'None') {
        contactValue = []
      } else {
        contactValue = typeof contactValue === "string" ?
        JSON.parse(contactValue) : contactValue
      }
      return contactValue
    },
    openItem (action, item) {
      item['Notification_List'] = this.verifyContactsValue(item['Notification_List']);
      item['IAM_Users'] = this.verifyContactsValue(item['IAM_Users']);
      item['Financial_Owner'] = this.verifyContactsValue(item['Financial_Owner']);

      this.$store.commit('admin/openAccountDialog', {
        show: true,
        type: action,
        showSelectCustomer: false,
        fields: { ...item },
        accountIdExist: true,
        mpIdExist: true,
        submitLabel: 'Update',
        submitHandler: () => {
          this.$store.dispatch('admin/updateAccount')
        }
      })
      this.$store.commit('setChangeLogRecord', { id: item.Acct_ID, changeFrom: { ...item } }, { root: true })
    },
    flagAccount (data) {
      this.$store.commit('showDialog', {
        show: true,
        yesHandler: () => {
          this.$store.commit('showDialog', { yesHandlerLoading: true }, { root: true })
          this.$store.dispatch('admin/accountInventory/delete', data)
        },
        noHandler: () => {
          this.$store.commit('showDialog', {
            show: false
          }, { root: true })
        },
        type: 'confirmation',
        persistent: true,
        title: 'Do you want to delete this Account ID:' + data.Acct_ID,
        yesLabel: 'Yes',
        noLabel: 'No'
      }, { root: true })
    },
    cloneAccount (item) {
      this.$store.commit('admin/openClonedAccount', {
        show: true,
        type: 'new',
        showSelectCustomer: false,
        fields: { ...item, Acct_ID: null },
        accountIdExist: true,
        mpIdExist: true,
        submitLabel: 'Create',
        submitHandler: (fields) => {
          this.$store.dispatch('admin/saveNewAccount', fields)
        }
      })
    },
    updateLastDateValidatedField () {
      let selectedAccount = {
        updatedLastDateValidated: this.lastDateVal,
        selected: this.selected
      }
      this.$store.dispatch('admin/accountInventory/updateFieldLastDateValidated', selectedAccount)
    },
    onShowLogs (account) {
      this.$store.dispatch('showLogRecords', account.Acct_ID)
    },
    unArchiveAccount (account) {
      this.$store.commit('showDialog', {
        show: true,
        yesHandler: () => {
          this.$store.commit('showDialog', { yesHandlerLoading: true }, { root: true })
          this.$store.dispatch('admin/accountInventory/unArchive', account)
        },
        noHandler: () => {
          this.$store.commit('showDialog', {
            show: false
          }, { root: true })
        },
        type: 'confirmation',
        persistent: true,
        title: Array.isArray(account) ? 'Do you want to restore the selected accounts:' : 'Do you want to restore this Account ID: ' + account.Acct_ID,
        yesLabel: 'Yes',
        noLabel: 'No'
      }, { root: true })
    },
    checkFieldPerm () {
      this.blurConfig.isBlurred = this.$store.state.viewCustomFields.isAllowed
      return true
    },
    daysMarkedAsUnknown (item) {
      let currentDate = new Date()
      let markedDate = new Date(item)
      let cDate = currentDate.valueOf()
      let mDate = markedDate.valueOf()

      let since_days = (cDate - mDate) / 1000 / 86400
      since_days = Math.round(since_days - 0.5)
      return since_days + (since_days > 1 ? ' Days ago.' : ' Day ago.')
    },
    downloadAccounts () {
      this.$store.dispatch('admin/accountInventory/downloadAccounts')
    },
    onRowClick (e) {
      let currentHoveredItem = document.querySelector('.current-item')
      if (currentHoveredItem) {
        currentHoveredItem.classList.remove('current-item')
      }
      e.target.closest('tr').classList.add('current-item')
    }
  },
  watch: {
    searchInput: debounce(function (newVal, oldVal) {
      this.$store.state['admin/accountInventory'].nextPaginationKey = null
      this.$store.state['admin/accountInventory'].accountDataFilters[this.searchField] = newVal
      this.$store.dispatch('admin/accountInventory/getAccounts')
    }, 1000),
    searchField: function (newVal, oldVal) {
      // clear search input
      this.searchInput = ''
      this.$store.commit('admin/accountInventory/removeSearchValue')
      this.$store.state['admin/accountInventory'].nextPaginationKey = null
      this.$store.state['admin/accountInventory'].accountDataFilters.field = newVal
    },
    agreementFilter: function (val) {
      this.$store.state['admin/accountInventory'].nextPaginationKey = null
      this.$store.state['admin/accountInventory'].accountDataFilters.Agreement = val
      this.$store.dispatch('admin/accountInventory/getAccounts')
    },
    accountStatusFilter: debounce(function (val) {
      this.$store.state['admin/accountInventory'].nextPaginationKey = null
      this.$store.state['admin/accountInventory'].accountDataFilters.Acct_Status = val
      this.$store.dispatch('admin/accountInventory/getAccounts')
    }, 1000),

    archivedAcctStatus: function (val) {
      this.$store.state['admin/accountInventory'].nextPaginationKey = null
      let accountStatuses = [] 
      if (val == '1') {
        accountStatuses = ['SUSPENDED', 'Moved to Client']
      } else {
        accountStatuses = ['ACTIVE', 'New']
      }
      this.$store.state['admin/accountInventory'].accountDataFilters.Acct_Status = accountStatuses
    },
    deletedFilter: function (val) {
      this.$store.state['admin/accountInventory'].nextPaginationKey = null
      this.$store.state['admin/accountInventory'].accountDataFilters.deleted = val
      this.$store.dispatch('admin/accountInventory/getAccounts')
    }
  }
}
</script>
<style lang="scss" scoped>
table.v-table thead th:first-child {
  font-size: 10px;
}

.masterDropdown {
  margin-bottom: 0;
  .theme--light.v-text-field--solo > .v-input__control > .v-input__slot {
    background: linear-gradient(60deg, #ffa726, #fb8c00) !important;
    color: #fff !important;
  }
  .theme--light.v-select .v-select__selections {
    color: #fff !important;
  }
  .theme--light.v-icon {
    color: #fff;
  }
}
.v-progress-linear {
      margin: 0;
      bottom: -15px;
  }

.mass-update-actions {
  background: rgba(65, 179, 223, 0.3);
}
</style>